import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentTypeSelector = ({ selectedType, onTypeChange }) => {
  const contentTypes = [
    {
      id: 'press-release',
      name: 'Press Release',
      description: 'Professional press releases for book launches and announcements',
      icon: 'FileText',
      color: 'bg-blue-50 border-blue-200 text-blue-700'
    },
    {
      id: 'social-media',
      name: 'Social Media',
      description: 'Platform-specific posts for Twitter, LinkedIn, and Instagram',
      icon: 'Share2',
      color: 'bg-green-50 border-green-200 text-green-700'
    },
    {
      id: 'blog-post',
      name: 'Blog Post',
      description: 'SEO-optimized blog content with topic suggestions',
      icon: 'Edit3',
      color: 'bg-purple-50 border-purple-200 text-purple-700'
    },
    {
      id: 'story-angles',
      name: 'Story Angles',
      description: 'Creative story angles and headline suggestions',
      icon: 'Lightbulb',
      color: 'bg-orange-50 border-orange-200 text-orange-700'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-foreground mb-4">Content Type</h3>
      <div className="grid grid-cols-1 gap-3">
        {contentTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeChange(type?.id)}
            className={`p-4 rounded-lg border-2 transition-all duration-200 text-left ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5 shadow-sm'
                : 'border-border hover:border-primary/50 hover:bg-muted/50'
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className={`p-2 rounded-md ${type?.color}`}>
                <Icon name={type?.icon} size={20} />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-foreground">{type?.name}</h4>
                <p className="text-sm text-muted-foreground mt-1">{type?.description}</p>
              </div>
              {selectedType === type?.id && (
                <Icon name="Check" size={20} className="text-primary" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContentTypeSelector;